import { Link } from "react-router-dom";

export default function NotFoundPage() {
  return (
    <div className="py-20 text-center">
      <p className="font-mono text-5xl font-bold text-brand">404</p>
      <h1 className="mt-4 text-xl font-semibold">Página não encontrada</h1>
      <Link
        to="/"
        className="mt-6 inline-block rounded-md border border-line px-4 py-2 text-sm text-ink-muted transition-colors hover:border-brand hover:text-brand"
      >
        Voltar ao início
      </Link>
    </div>
  );
}
